<template>
  <v-dialog v-model="isVisible"
            no-click-animation
            max-width="50%">
    <v-card v-if="item">
      <v-card-text>
        <v-layout xs12>
          <v-flex xs6 v-if="!rowItem.hasPaymentOrder">
            <v-btn class="primary" dark text @click="optionEvent(31)">產生繳款單</v-btn>
          </v-flex>
          <v-flex xs6 v-if="rowItem.hasPaymentOrder">
            <v-btn class="success" dark text @click="optionEvent(34, rowItem)">查詢繳款單明細</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn class="primary" dark text @click="optionEvent(32)">繳款單紀錄</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12>
          <v-flex xs6>
            <v-btn class="primary" dark text @click="optionEvent(33)">設定撥款資料</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="(isAdmin || isStaff) && !isUpdateAction">
          <v-flex xs6>
            <v-btn class="primary" dark text @click="optionEvent(7)">修改案件編號</v-btn>
          </v-flex>
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(30)">變更專案代碼</v-btn>-->
<!--          </v-flex>-->
        </v-layout>
        <br>
<!--        <v-layout xs12 v-if="item.category !== 2 && !isUpdateAction">-->
<!--          <v-flex xs6>-->
<!--            <v-btn v-if="platform !== 1" class="primary" dark text @click="optionEvent(11)">轉和潤</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6>-->
<!--            <v-btn v-if="platform !== 2" class="primary" dark text @click="optionEvent(12)">轉中租</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12  v-if="item.category !== 2 && !isUpdateAction">-->
<!--          <v-flex>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(16)">轉CA</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
        <v-layout xs12 v-if="(isAdmin || isStaff || getUserInfo.enableAgentContract === true) && !isUpdateAction">
          <v-flex xs6>
            <v-btn class="primary" dark text @click="optionEvent(6)">代辦合約書</v-btn>
          </v-flex>
<!--          <v-flex xs6 v-if="item.category === 0 || item.category === 3">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(13)">補保人</v-btn>-->
<!--          </v-flex>-->
        </v-layout>
        <br>
        <v-layout xs12 v-if="!isUpdateAction">
          <v-flex xs6>
            <v-btn class="primary" dark text @click="optionEvent(8)">案件對保資料</v-btn>
          </v-flex>
          <v-flex xs6 v-if="item.category !== 2">
            <v-btn class="primary" dark text @click="optionEvent(5)">動產抵押契約書</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="!isUpdateAction">
          <v-flex xs6 v-if="item.category !== 2">
            <v-btn class="primary" dark text @click="optionEvent(9)">案件設定</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn class="primary" dark text @click="optionEvent(10)">修改經辦人</v-btn>
          </v-flex>
        </v-layout>
        <br>
<!--        <v-layout xs12 v-if="!isUpdateAction">-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(0)">列印</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(1)">其他表單</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12>-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(2)">圖片上傳</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(3)">PDF上傳</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="(platform === 0 || platform === 3 ) && !isUpdateAction">-->
<!--          <v-flex xs6 v-if="getUserInfo.enableQueryCaseStatus">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(25)">新增保人</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark text @click="confirmEvent">關閉</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import common from '@/mixins/common';

export default {
  name: 'CCHFinanceCreditDialog',
  props: {
    visible: Boolean,
    item: Object,
    platform: Number,
    rowItem: Object,
    isUpdateAction: Boolean
  },
  data() {
    return {
      loading: false,
      valid: true,
      dialog: false,
      isVisible:false,
      dealer_branch_no: '',
    };
  },
  watch:{
    visible(value){
      this.isVisible = value;
      this.fetchAgentList().then(() => {
        const find = this.getAgentList.find(agent=>agent.agentId === this.rowItem.agentId);
        if (find){
          this.dealer_branch_no = find.dealerBranchNo ? find.dealerBranchNo : '0001';
        }
        console.log(`find agent == ${JSON.stringify(find)}`);
      });
    },
    isVisible(value){
      if(!value)
      {
        this.$emit('closeEvent');
      }
    },
    item(value){
      console.log(`item == ${JSON.stringify(value)}`);
    },
    rowItem(value){
      console.log(`rowItem == ${JSON.stringify(value)}`);
    }
  },
  mixins: [common],
  computed:{
    ...mapGetters(['getUserInfo','getAgentList']),
    isShowSearchBonus() {
      if(!this.rowItem) {
        return false
      }
      return  this.rowItem.bonus === 0
    }
  },
  methods: {
    ...mapActions(['fetchAgentList']),
    optionEvent(eventKey, info){
      this.$emit('showEvent', { key: eventKey, info: info });
    },
    confirmEvent(){
      this.$emit('confirmEvent', true);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CCHFinanceCreditDialog.vue